import { FunctionComponent, useState } from 'react'
import { get } from 'libraries/lodash'
import cx from 'classnames'
import ellipsis from 'text-ellipsis'
import Selector from 'components/accordion/Selector'
import { AccordionHeaderProps, toDataProps } from 'components/accordion/AccordionHeader'
import ContentHeaderLabelContainer from 'redux/containers/components/accordion/ContentHeaderLabelContainer'
import { ContentHeaderContainerProps } from 'redux/containers/components/accordion/ContentHeaderContainer'
import { Flavour } from 'types/Flavour'
import { dismissPopover } from 'services/OverlayService'
import AccordionHeaderToolTip from './AccordionHeaderToolTip'

const ContentHeader: FunctionComponent<ContentHeaderProps> = ({
  aol,
  atBottom,
  className,
  depth,
  id,
  nodeId,
  prefix,
  selected,
  suffix,
  title = '',
  flavour,
  cxNames,
  isHighlighted = false,
  eventCategory,
  urlNode,
  path,
  expanded,
  hasAccess = true
}) => {
  const Suffix = (suffix !== undefined && suffix !== '') ? <span>{suffix}</span> : null
  if ((title === undefined || title === '') && (prefix === undefined || prefix === null || prefix === '')) {
    return null
  }

  const getBackgroundOverride = (): string => {
    if (isHighlighted) return 'highlight-yellow'
    if (!hasAccess) return 'bg-moon-gray o-60'
    return get(cxNames, 'contentHeader.headerBackground', '')
  }
  const backgroundOverride = getBackgroundOverride()

  const props = Object.assign(
    { className },
    toDataProps({
      id,
      depth,
      nodeId,
      title: title !== undefined && title !== '' ? title : '-',
      prefix,
      suffix,
      type: 'content',
      expanded
    })
  )

  if (selected !== undefined) {
    Object.assign(props, toDataProps({ selected }))
  }

  Object.assign(
    props,
    toDataProps({ helpItem: (expanded) ? 'accordioncontentexpanded' : 'accordioncontentcollapsed' })
  )

  return (
    <div {...props} className={cx('relative flex items-center justify-between min-h3 w-100', backgroundOverride)}>
      <ContentHeaderLabelContainer {...{ aol, id, nodeId, depth, atBottom, expanded, prefix, title, eventCategory, path, hasAccess }}>
        {(prefix !== undefined && prefix !== null && prefix !== '') && <ContentHeaderPrefix {...{ prefix, depth, nodeId, urlNode }} />}
      </ContentHeaderLabelContainer>
      <div
        className='mr8'
        onClick={(e) => {
          dismissPopover(e.target)
          e.stopPropagation()
        }}
      >
        <div className='mr4 flex items-center'>
          {Suffix}
          {hasAccess && <Selector type='content' {...{ aol, atBottom, id, selected, title, flavour, expanded }} />}
        </div>
      </div>
    </div>
  )
}

const ContentHeaderPrefix: FunctionComponent<ContentHeaderPrefixProps> = ({ prefix, depth, nodeId, urlNode }) => {
  const [hover, setHover] = useState(false)
  const maxCharLength = 7
  return (
    <span
      className={cx(
        'absolute mv5 f5 w9',
        { underline: nodeId === urlNode }
      )}
      style={{ marginLeft: `${depth - 1}rem` }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <>
        {prefix.length > maxCharLength && (
          <AccordionHeaderToolTip open={hover} title={prefix} placement='left' arrow>
            <div className='pr4'>
              {ellipsis(prefix, maxCharLength, { side: 'start' })}
            </div>
          </AccordionHeaderToolTip>
        )}

        {prefix.length <= maxCharLength && prefix}
      </>
    </span>
  )
}

interface ContentHeaderPrefixProps {
  prefix: string
  depth: number
  nodeId: string
  urlNode: string
}

export interface ContentHeaderProps extends ContentHeaderContainerProps, AccordionHeaderProps {
  aol?: string | string[]
  nodeId: string
  title?: string
  flavour?: Flavour
  urlNode: string
  hasAccess?: boolean
}

export default ContentHeader
